import { CHAIN_CONFIG, GRX_CHAIN_ID, SupportedChainId, isSupportedChainId } from 'config/constants/chains'

export const nodes = CHAIN_CONFIG[GRX_CHAIN_ID].rpcUrls

export const getRpcUrlByChain = (chainId?: number): string => {
  const selectedChainId: SupportedChainId = isSupportedChainId(chainId) ? chainId : GRX_CHAIN_ID
  return CHAIN_CONFIG[selectedChainId].rpcUrls[0]
}

const getNodeUrl = (): string => {
  const configuredChainId = Number(process.env.NEXT_PUBLIC_CHAIN_ID)
  return getRpcUrlByChain(configuredChainId)
}

export default getNodeUrl
